import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const GameInfoWrapper = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1.5, 2),
  background: theme.palette.bg.secondary,
  marginTop: theme.spacing(3),
  borderRadius: theme.spacing(1),
  border: theme.palette.border.normal,
}));

export const GameInfoHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  cursor: 'pointer',
}));

export const GameInfoContent = styled(Box)(({ theme }) => ({
  fontFamily: 'Readex Pro',
  fontSize: '14px',
  fontWeight: 400,
}));

export const StyledRuleItem = styled('div')(({ theme }) => ({
  display: 'flex',
  whiteSpace: 'pre-line',
  marginBottom: theme.spacing(1),
  '&>span': {
    minWidth: '20px',
  },
}));

export const StyledImageWrapper = styled('div')(({ theme }) => ({
  width: '80%',
  height: 'auto',
  marginBottom: theme.spacing(1),
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}));

export const GameInfoImageWrapper = styled(Box)(({ theme }) => ({
  borderRadius: theme.spacing(1),
  overflow: 'hidden',
  position: 'relative',
}));

export const StyledTextItem = styled('div')(({ theme }) => ({
  display: 'flex',
  whiteSpace: 'pre-line',
  marginBottom: theme.spacing(1),
  '&>span': {
    minWidth: '20px',
  },
}));
